import React from "react";
import { useContext } from "react";
import UserContext from "../context/userContext";
import IconProjectExternal from "../components/VectorIcons/IconProjectExternal";
import { HeaderActivitiesIcon } from "../components/VectorIcons/HeaderActivitiesIcon";
import { HeaderReleasedTextsIcon } from "../components/VectorIcons/HeaderReleasedTextsIcon";
import { HeaderSharedTextsIcon } from "../components/VectorIcons/HeaderSharedTextsIcon";
import { HeaderRegisterIcon } from "../components/VectorIcons/HeaderRegisterIcon";
import { HeaderProductionCompaniesIcon } from "../components/VectorIcons/HeaderProductionCompaniesIcon";
import { HeaderProspectsIcon } from "../components/VectorIcons/HeaderProspectsIcon";
import { HeaderThesaurusIcon } from "../components/VectorIcons/HeaderThesaurusIcon";
import { ReactComponent as CultureHubIcon } from "../assets/icons/hub-cultura.svg";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";

// Single source of truth for which app routes appear in navigation menus, shared by the
// legacy Header's overflow menu and the Globo Marca navigation drawer
const useNavigationMenuLinks = () => {
  const { hasPermission, userIsRole, userIsNotMonoPermission } =
    useContext(UserContext);

  const permissionedPages = [
    {
      show:
        hasPermission({ required: ["Dramaturgies"] }) ||
        hasPermission({ required: ["Varieties"] }) ||
        hasPermission({ required: ["Researches"] }) ||
        hasPermission({ required: ["LiteraryWorks"] }),
      to: "/cadastrar",
      label: "Cadastro",
      icon: <HeaderRegisterIcon />,
    },
    {
      show: hasPermission({ required: ["Activities"] }),
      to: "/atividades",
      label: "Atividades",
      icon: <HeaderActivitiesIcon />,
    },
    {
      show: hasPermission({ required: ["ExternalProject"] }),
      to: "/projetos-externos",
      label: "Projetos Externos",
      icon: <IconProjectExternal color="#36355A" />,
    },
    {
      show: hasPermission({ required: ["TextRelease"] }),
      to: "/textos-liberados",
      label: "Textos Liberados",
      icon: <HeaderReleasedTextsIcon />,
    },
    {
      show: hasPermission({ required: ["AttachmentViewer"] }),
      to: "/textos-compartilhados",
      label: "Textos Compartilhados",
      icon: <HeaderSharedTextsIcon />,
    },
    {
      show: userIsRole("CultureHub") || userIsRole("Admin"),
      to: "/hub-cultura",
      label: "HUB de Cultura",
      icon: <CultureHubIcon />,
      showSeparatorAbove: true,
    },
    {
      show: hasPermission({ required: ["ProductionCompanies"] }),
      to: "/produtoras",
      label: "Produtoras",
      icon: <HeaderProductionCompaniesIcon />,
      showSeparatorAbove: true,
    },
    {
      show: hasPermission({ required: ["Prospects"] }),
      to: "/proponentes",
      label: "Proponentes",
      icon: <HeaderProspectsIcon />,
    },
    {
      show: hasPermission({ required: ["Thesaurus"] }),
      to: "/admin/thesaurus",
      label: "Thesaurus",
      icon: <HeaderThesaurusIcon />,
    },
    {
      show: userIsRole("Admin"),
      to: "/maintenance",
      label: "Manutenção",
      icon: <AdminPanelSettingsOutlinedIcon />,
      showSeparatorAbove: true,
    },
  ];

  const allowedPages = permissionedPages.filter((page) => page.show);

  return { allowedPages, showNavigationMenu: userIsNotMonoPermission() };
};

export default useNavigationMenuLinks;
